import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ModelosDeDownloadModalComponent } from 'src/app/modals/modelos-de-download-modal/modelos-de-download-modal.component';
import { TipoArquivo } from 'src/app/models/enum';
import { Filtro } from 'src/app/models/filtro';
import { ModeloDownloadAnexo } from 'src/app/models/modelo-download-anexo';
import { PedidoAnexo } from 'src/app/models/pedido-anexo';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { ModeloDownloadAnexoService } from 'src/app/services/modelo-download-anexo.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoAnexoService } from 'src/app/services/pedido-anexo.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarPedidoAnexoComponent } from './cadastrar-pedido-anexo/cadastrar-pedido-anexo.component';
import { PremissasSistema } from 'src/app/models/premissas-sistema';

declare const $: any;

@Component({
  selector: 'app-pedido-anexo',
  templateUrl: './pedido-anexo.component.html',
  styleUrls: ['./pedido-anexo.component.scss']
})
export class PedidoAnexoComponent implements OnInit, OnDestroy {

  // variáveis
  // funis: PedidoAnexo[] = [];
  idPedido;
  pedidoAnexosFiltrados: PedidoAnexo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};
  modelos: ModeloDownloadAnexo[] = [];
  integrador = false;
  bloqExcluirAnexo = false;
  administrador = false;
  idUsuario = 0;

  origem = 0;

  modificou = false;
  premissasSistema = new PremissasSistema();

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(private pedidoAnexoService: PedidoAnexoService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, public dialog: MatDialog, private arquivoService: ArquivoService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private premissasService: PremissasService,
    public dialogRef: MatDialogRef<PedidoAnexoComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private modeloDownloadAnexoService: ModeloDownloadAnexoService,) {
    if (data.origem !== null && data.origem !== undefined) {
      this.origem = data.origem;
    }
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();
    this.editavel = this.data.podeEditar;
    this.idPedido = this.data.idPedido;
    this.idUsuario = (await this.globalService.consultaUsuario()).id;
    this.buscarPedidoAnexos();
    this.buscarModelosDownload();
    this.buscarBloqExcluirAnexo();
    this.buscarPremissasSistema();
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {

    if (campo) {

      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {

    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPedidoAnexos();
    this.paginator.firstPage();
  }

  buscarPedidoAnexos() {
    this.carregandoService.mostra('buscaPedidoAnexos');
    this.carregando = true;

    this.pedidoAnexoService.consultarPedidoAnexosComPaginacao(
      this.idPedido
      , this.filtroNome.Valor
      , this.paginacao.paginaAtual
      , this.itensPorPagina
      , this.campoOrdenacao
      , this.ordenarDesc ? 'desc' : 'asc'
      , this.origem
    ).subscribe(dados => {
      this.pedidoAnexosFiltrados = dados.itens;

      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaPedidoAnexos');
    }, (erro) => {
      this.carregandoService.esconde('buscaPedidoAnexos');
      this.notificacaoService.erro(erro);
    });


  }


  modelosDeDownload() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(ModelosDeDownloadModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { idPedido: this.idPedido },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  novoPedidoAnexo() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarPedidoAnexoComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { idPedido: this.idPedido, origem: this.origem },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.modificou = true;
        this.buscarPedidoAnexos();
      }
    });
  }

  editarPedidoAnexo(pedidoAnexo: PedidoAnexo) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarPedidoAnexoComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { id: pedidoAnexo.id, idPedido: this.idPedido, origem: this.origem, tipo: pedidoAnexo.tipo, idUsuarioAnexo: pedidoAnexo.idUsuario },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.modificou = true;
        this.buscarPedidoAnexos();
      }
    });
  }

  baixarArquivo(anexo: PedidoAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.PedidoAnexo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  visualizarArquivo(anexo: PedidoAnexo) {
    this.carregandoService.mostra('visualizarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.PedidoAnexo).subscribe(arq => {
      if (this.utilitarioService.ePDF(anexo.arquivo)) {
        this.utilitarioService.openBlobModal(arq, anexo.arquivo);
      } else if (this.utilitarioService.eImagem(anexo.arquivo)) {
        this.utilitarioService.mostrarImagemBlob(arq, anexo.arquivo);
      } else {
        this.utilitarioService.saveBlob(arq, anexo.arquivo);
      }
      this.carregandoService.esconde('visualizarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('visualizarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  baixarModelo(anexo: ModeloDownloadAnexo) {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.ModeloDownload).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }


  buscarModelosDownload() {
    this.carregandoService.mostra('buscarModelosDownload');
    this.carregando = true;

    this.modeloDownloadAnexoService.consultaModeloDownloadAnexos().subscribe(dados => {
      this.modelos = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscarModelosDownload');
    }, (erro) => {
      this.carregandoService.esconde('buscarModelosDownload');
      this.notificacaoService.erro(erro);
    });
  }

  excluirPedidoAnexo(pedidoAnexo: PedidoAnexo) {

    if (this.editavel && !this.integrador &&
      ((this.premissasSistema.somenteAdmExcluiAnexoPedido && this.administrador)
        || (!this.premissasSistema.somenteAdmExcluiAnexoPedido && (!this.bloqExcluirAnexo || (this.bloqExcluirAnexo && (this.administrador || (pedidoAnexo.tipo === 0 && pedidoAnexo.idUsuario === this.idUsuario))))))) {

      swal({
        title: 'Atenção!!',
        text: 'Deseja realmente excluir o Anexo?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {

          this.carregandoService.mostra('excluiPedidoAnexo');
          this.pedidoAnexoService.excluir(pedidoAnexo.id).subscribe(resp => {

            this.notificacaoService.sucesso('Anexo excluído com sucesso!!!');
            this.carregandoService.esconde('excluiPedidoAnexo');
            this.filtra();
            this.modificou = true;

          }, (erro) => {
            this.carregandoService.esconde('excluiPedidoAnexo');
            this.notificacaoService.erro(erro);
          });

        }
      });
    }

  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPedidoAnexos();
  }

  ngOnDestroy(): void {

  }

  fechar() {
    this.dialogRef.close(this.modificou);
  }

  buscarBloqExcluirAnexo() {
    this.carregandoService.mostra('consultarBloqExcluirAnexo');
    this.premissasService.consultarBloqExcluirAnexo().subscribe(
      (f) => {
        this.bloqExcluirAnexo = f.valor;
        this.carregandoService.esconde('consultarBloqExcluirAnexo');
      },
      (erro) => {
        this.carregandoService.esconde('consultarBloqExcluirAnexo');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
